// Service worker registration with auto-update detection.
// Registers /sw.js, polls for a fresh worker every 60s while the page is open,
// and triggers a callback when an update is waiting so the UI can show a banner.
export function registerServiceWorker({ onUpdate, onReady } = {}) {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    const swUrl = "/sw.js";

    const doRegister = () => {
        navigator.serviceWorker
            .register(swUrl)
            .then((reg) => {
                // If a SW is already waiting, surface it
                if (reg.waiting) {
                    onUpdate?.(reg);
                }

                // Detect newly installed waiting workers
                reg.addEventListener("updatefound", () => {
                    const installing = reg.installing;
                    if (!installing) return;
                    installing.addEventListener("statechange", () => {
                        if (installing.state === "installed" && navigator.serviceWorker.controller) {
                            // New version available
                            onUpdate?.(reg);
                        }
                    });
                });

                onReady?.(reg);

                // Periodic update check — every 60s while the tab is foreground
                const tick = () => {
                    if (document.visibilityState === "visible") {
                        reg.update().catch(() => {});
                    }
                };
                setInterval(tick, 60 * 1000);
                document.addEventListener("visibilitychange", () => {
                    if (document.visibilityState === "visible") tick();
                });
            })
            .catch(() => {
                // silently ignore registration failure (dev / unsupported browser)
            });

        // Auto-reload once the new SW takes control
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
        });
    };

    if (document.readyState === "complete") {
        doRegister();
    } else {
        window.addEventListener("load", doRegister, { once: true });
    }
}

export function activateWaitingWorker(reg) {
    if (reg && reg.waiting) {
        reg.waiting.postMessage({ type: "SKIP_WAITING" });
    }
}
